import { API_MARKETING_PATH, getMarketingClient } from '../api';
import {
  BrandTemplate,
  CreateMarketingDesignAutofillJobRequest,
  CreateMarketingDesignExportJobRequest,
  Design,
  GetMarketingFolderItemsRequest,
  MarketingDesignAutofillJob,
  MarketingDesignExportJob,
  MarketingFolder,
  MarketingFolderItem,
  MarketingPaginatedResponse,
  MarketingPaginationParams,
} from '../dtos';

export const searchBrandTemplates = async (
  query?: string,
  pagination?: MarketingPaginationParams,
): Promise<MarketingPaginatedResponse<BrandTemplate>> => {
  const client = await getMarketingClient();
  const { data } = await client.get<MarketingPaginatedResponse<BrandTemplate>>(`${API_MARKETING_PATH}/brand-templates/search`, {
    params: {
      query,
      limit: pagination?.limit,
      continuation: pagination?.continuation,
    },
  });

  return data;
};

export const searchDesigns = async (
  query?: string,
  pagination?: MarketingPaginationParams,
): Promise<MarketingPaginatedResponse<Design>> => {
  const client = await getMarketingClient();
  const { data } = await client.get<MarketingPaginatedResponse<Design>>(`${API_MARKETING_PATH}/designs/search`, {
    params: {
      query,
      limit: pagination?.limit,
      continuation: pagination?.continuation,
    },
  });

  return data;
};

export const createMarketingDesignExportJob = async (
  req: CreateMarketingDesignExportJobRequest,
): Promise<MarketingDesignExportJob> => {
  const client = await getMarketingClient();
  const { data } = await client.post<MarketingDesignExportJob>(`${API_MARKETING_PATH}/jobs/exports`, req);

  return data;
};

export const getMarketingDesignExportJob = async (jobId: string): Promise<MarketingDesignExportJob> => {
  const client = await getMarketingClient();
  const { data } = await client.get<MarketingDesignExportJob>(`${API_MARKETING_PATH}/jobs/exports/${jobId}`);

  return data;
};

export const getMarketingDesignAutofillJob = async (jobId: string): Promise<MarketingDesignAutofillJob> => {
  const client = await getMarketingClient();
  const { data } = await client.get<MarketingDesignAutofillJob>(`${API_MARKETING_PATH}/jobs/autofills/${jobId}`);

  return data;
};

export const getBrandTemplate = async (id: string): Promise<BrandTemplate> => {
  const client = await getMarketingClient();
  const { data } = await client.get<BrandTemplate>(`${API_MARKETING_PATH}/brand-templates/${id}`);

  return data;
};

export const getMarketingDesign = async (id: string): Promise<Design> => {
  const client = await getMarketingClient();
  const { data } = await client.get<Design>(`${API_MARKETING_PATH}/designs/${id}`);

  return data;
};

export const createMarketingDesignAutofillJob = async (
  req: CreateMarketingDesignAutofillJobRequest,
): Promise<MarketingDesignAutofillJob> => {
  const client = await getMarketingClient();
  const { data } = await client.post<MarketingDesignAutofillJob>(`${API_MARKETING_PATH}/jobs/autofills`, req);

  return data;
};

export const getMarketingFolder = async (id: string): Promise<MarketingFolder> => {
  const client = await getMarketingClient();
  const { data } = await client.get<MarketingFolder>(`${API_MARKETING_PATH}/folders/${id}`);

  return data;
};

export const getMarketingFolderItems = async (
  req: GetMarketingFolderItemsRequest,
  pagination?: MarketingPaginationParams,
): Promise<MarketingPaginatedResponse<MarketingFolderItem>> => {
  const client = await getMarketingClient();

  const { data } = await client.get<MarketingPaginatedResponse<MarketingFolderItem>>(`${API_MARKETING_PATH}/folders/${req.folderId}/items`, {
    params: {
      itemType: req.itemType,
      limit: pagination?.limit,
      continuation: pagination?.continuation,
    },
  });

  return data;
};
